/**
 * WaveMark — le motif de vague du logo, en signe autonome.
 *
 * POURQUOI IL EXISTE. Deux endroits du site utilisaient une étoile à quatre
 * branches (✦) comme ornement : le séparateur éditorial et le sceau du tier
 * premium sur la home. Jade l'a relevé — « l'étoile ne fait plus partie de la
 * marque ». C'est exact : la charte V6 tient au drapeau sur mât, à la skyline
 * et aux vagues ; l'étoile ne vient de nulle part.
 *
 * ⚠️ Le sceau du tier premium devrait à terme porter l'AIGLE HARPIE, que la
 * charte réserve précisément aux produits premium / tier-1. Aucun asset
 * n'existe dans public/brand/ — en inventer un serait pire que la vague.
 * À reprendre quand l'emblème sera dessiné.
 *
 * Composant partagé plutôt que SVG recopié aux deux endroits : une copie
 * divergerait au premier ajustement (cf. tests/no-divergence.test.js).
 *
 * @param {object} props
 * @param {number} [props.width=34]
 * @param {string} [props.className]
 */
export default function WaveMark({ width = 34, className = '' }) {
  const height = Math.round((width * 10) / 34);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 10"
      fill="none"
      focusable="false"
      aria-hidden="true"
      className={className}
    >
      {/* Océan #17726F en dur, pas `currentColor` : la couleur secondaire ne
          doit jamais disparaître, et le motif reste lisible aussi bien sur le
          papier os que sur le noir du mode sombre. */}
      <path
        d="M1 6.2c2.7-3.6 5.3-3.6 8 0s5.3 3.6 8 0 5.3-3.6 8 0 5.3 3.6 8 0"
        stroke="#17726F"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
